import axios from "axios";
import { getExperienceApi } from '../_constants/api.constant'
import {  getSelfToken } from '../../_helpers/auth/secureToken'
export async function updateExperience(postData,experienceId) {
    const response = await axios.put(
        getExperienceApi.UPDATE,
        postData,
        {   params:{id:experienceId},
            headers: {
                Authorization: 'Token ' + getSelfToken(),
            },
        }
    ).then(function (response) {
        return response;
    }).catch(function (error) {
        // handle error
        console.log(error);
        console.log(error.response);
        return error.response;
    });
    return response;
}